import React, { useEffect, useState } from "react";
import "../assets/styles/clock.css";
import { pad } from "../utils";

export const Clock = ({ options }) => {
  const [hourDeg, setHourDeg] = useState(180);
  const [minuteDeg, setMinuteDeg] = useState(180);
  const [secondsDeg, setSecondsDeg] = useState(180);
  const [hours, setHour] = useState(0);
  const [minutes, setMinute] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    let interval = setInterval(() => {
      let date = new Date();
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();

      setHourDeg(h * 30 + 180);
      setMinuteDeg(m * 6 + 180);
      setSecondsDeg(s * 6 + 180);
      setHour(h);
      setMinute(m);
      setSeconds(s);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [hourDeg, minuteDeg, secondsDeg]);

  return (
    <div className="clock-container">
      {options.showAnalogClock && (
        <div className="clock">
          <div className="clock-border">
            <div className="clock-mid"></div>
            <div className="clock-faces">
              <span
                className="clock-face clock-hour-face"
                style={{
                  transform: `translate3d(-50%, 0%, 0) rotateZ(${hourDeg}deg)`,
                }}
              />
              <span
                className="clock-face clock-minute-face"
                style={{
                  transform: `translate3d(-50%, 0%, 0) rotateZ(${minuteDeg}deg)`,
                }}
              />
              <span
                className="clock-face clock-seconds-face"
                style={{
                  transform: `translate3d(-50%, 0%, 0) rotateZ(${secondsDeg}deg)`,
                }}
              />
            </div>
          </div>
        </div>
      )}
      {options.showDigitalClock && (
        <div>
          <span className="hr-hour">{pad(hours)}</span>
          <span className="hr-hour">{pad(minutes)}</span>
          <span className="hr-hour">{pad(seconds)}</span>
        </div>
      )}
    </div>
  );
};
